import {createSlice} from '@reduxjs/toolkit'

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        userDetails: {},
        subscriptionPromotions: [],
        buildings: [],
        isLandlord: false
    },
    reducers: {
        setUserDetails: (state, action) => {
            state.userDetails = action.payload
        },
        setSubscriptionPromotions: (state, action) => {
            state.subscriptionPromotions = action.payload
        },
        setBuildings: (state, action) => {
            state.buildings = action.payload
        },
        setIsLandlord: (state, action) => {
            state.isLandlord = action.payload
        }
    }

})

// Action creators are generated for each case reducer function
export const { setUserDetails, setSubscriptionPromotions, setBuildings, setIsLandlord } = userSlice.actions

export default userSlice.reducer

